module.exports = __webpack_public_path__ + "img/ec.d4dcf221.svg";